import styled from "styled-components";
import MUIDataTable from "mui-datatables";

export const Table = styled(MUIDataTable)`
  width: 100%;
  box-shadow: none !important;
`;
